import t from 'react-translate';
import { css } from '@emotion/react';
import useTimeZone from 'athena/hooks/use-time-zone';
import { headerLineHeight } from 'styles/global_defaults/fonts';
import { black, gray2, gray7 } from 'styles/global_defaults/colors';
import {
  halfSpacing,
  quarterSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';
import { formatSessionTime } from './utils';

type SessionDetailsProps = {
  title: string;
  scheduledDate: string;
};

const styles = css`
  border-radius: ${quarterSpacing}px;
  padding: ${halfSpacing}px ${standardSpacing}px;
  background-color: ${gray7};

  .details-header {
    color: ${gray2};
  }
  .details-content {
    color: ${black};
    line-height: ${headerLineHeight}px;
  }
`;

const SessionDetails = ({ title, scheduledDate }: SessionDetailsProps) => {
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.SESSION_PULSE_CHECK.FORM;
  const timeZoneData = useTimeZone();
  // When Integrated Session Planner feature is added, session will have a duration
  // we will make changes when that happens
  // for testing purposes, we are using a default duration of 1 hour
  const DURATION_IN_MINUTES = 60;
  const dateTime = formatSessionTime(
    scheduledDate,
    DURATION_IN_MINUTES,
    timeZoneData,
  );

  return (
    <div css={styles} className='d-flex pulse-check-session-details'>
      <div className='w-100'>
        <div className='details-header text-small'>
          {translationBase.SESSION_NAME_TITLE()}
        </div>
        <div className='details-content semi-bold text-regular py-1'>
          {title}
        </div>
      </div>
      <div className='w-100'>
        <div className='details-header text-small'>
          {translationBase.SESSION_DATE_TIME_TITLE()}
        </div>
        <div className='details-content semi-bold text-regular py-1'>
          {dateTime}
        </div>
      </div>
    </div>
  );
};

export default SessionDetails;
